import { render, staticRenderFns } from "./districtsAdd.vue?vue&type=template&id=e3084d7a&scoped=true&"
import script from "./districtsAdd.vue?vue&type=script&lang=js&"
export * from "./districtsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3084d7a",
  null
  
)

export default component.exports